import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M764.340706,56 L990.223059,394.823529 L1919.95482,394.823529 L1919.95482,959.529412 L1807.01365,959.529412 L1807.01365,507.764706 L225.837176,507.764706 L225.837176,394.823529 L854.467765,394.823529 L703.917176,168.941176 L112.896,168.941176 L112.896,1580.70588 C112.896,1611.87765 138.307765,1637.17647 169.366588,1637.17647 L169.366588,1637.17647 L1127.10776,1637.17647 L1127.10776,1750.11765 L169.366588,1750.11765 C75.9642353,1750.11765 -0.0451764706,1674.10824 -0.0451764706,1580.70588 L-0.0451764706,1580.70588 L-0.0451764706,56 L764.340706,56 Z M1807.05882,1411.29412 L1807.05882,1693.64706 C1807.05882,1724.81882 1781.64706,1750.11765 1750.58824,1750.11765 L1411.76471,1750.11765 C1380.70588,1750.11765 1355.29412,1724.81882 1355.29412,1693.64706 L1355.29412,1411.29412 L1807.05882,1411.29412 Z M1581.17647,1072.47059 C1643.52,1072.47059 1694.11765,1123.18118 1694.11765,1185.41176 L1694.11765,1298.35294 L1468.23529,1298.35294 L1468.23529,1185.41176 C1468.23529,1123.18118 1518.83294,1072.47059 1581.17647,1072.47059 Z M1807.05882,1185.41176 C1807.05882,1060.83765 1705.75059,959.529412 1581.17647,959.529412 C1456.60235,959.529412 1355.29412,1060.83765 1355.29412,1185.41176 L1355.29412,1298.35294 L1242.35294,1298.35294 L1242.35294,1693.64706 C1242.35294,1787.04941 1318.36235,1863.05882 1411.76471,1863.05882 L1750.58824,1863.05882 C1843.99059,1863.05882 1920,1787.04941 1920,1693.64706 L1920,1298.35294 L1807.05882,1298.35294 L1807.05882,1185.41176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFolderLockedLine = /*#__PURE__*/function (_Component) {
  _inherits(IconFolderLockedLine, _Component);

  var _super = _createSuper(IconFolderLockedLine);

  function IconFolderLockedLine() {
    _classCallCheck(this, IconFolderLockedLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconFolderLockedLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFolderLocked",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconFolderLockedLine.displayName = "IconFolderLockedLine";
  return IconFolderLockedLine;
}(Component);

IconFolderLockedLine.glyphName = 'folder-locked';
IconFolderLockedLine.variant = 'Line';
IconFolderLockedLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFolderLockedLine;
export { IconFolderLockedLine };